export enum EventStatusEnum {
    DRAFT = 0,
    ACTIVE = 1,
    CANCELLED = 2
}